/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ApiErrors, IFormValues } from "./types";
import { Trans } from "react-i18next";
import React from "react";

type Rule = {
  [key: string]: unknown;
};

export function updateApiErrors(
  apiErrors: ApiErrors,
  changedValues: IFormValues
): [boolean, ApiErrors] {
  const newApiErrors = { ...apiErrors };
  let isUpdated = false;

  for (const field in changedValues) {
    if (field in apiErrors) {
      delete newApiErrors[field];
      isUpdated = true;
    }
  }

  return [isUpdated, newApiErrors];
}

export function buildEmailRule(t?: any): Rule {
  return {
    type: "email",
    message: <Trans t={t} i18nKey="web_email_validation_message" />,
  };
}

export function buildPasswordMinimumRule(t?: any): Rule {
  return {
    min: 10,
    message: (
      <Trans
        t={t}
        i18nKey="web_minimum_password_validation_message"
        defaults="Password requires minimum 10 characters"
      />
    ),
  };
}

export function buildPasswordMaximumRule(t?: any): Rule {
  return {
    max: 60,
    message: (
      <Trans
        i18nKey={
          t
            ? t("web_maximum_password_validation_message")
            : "web_maximum_password_validation_message"
        }
        defaults="Password requires maximum 60 characters"
      />
    ),
  };
}

export * from "./types";
